"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringPT = exports.numberPT = exports.numberOrStringPT = exports.nodePT = exports.momentStringPT = exports.momentObjectOrStringPT = exports.momentObjectPT = exports.funcPT = exports.emptyObjectPT = exports.boolPT = exports.string = exports.oneOfType = exports.number = exports.node = exports.func = exports.bool = undefined;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMomentProptypes = require("react-moment-proptypes");

var _empty = require("../constants/empty");

var _isRequired = require("../utils/isRequired");

var _isRequired2 = _interopRequireDefault(_isRequired);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    node = _propTypes2.default.node,
    number = _propTypes2.default.number,
    oneOfType = _propTypes2.default.oneOfType,
    string = _propTypes2.default.string;
exports.bool = bool;
exports.func = func;
exports.node = node;
exports.number = number;
exports.oneOfType = oneOfType;
exports.string = string;

var boolPT = exports.boolPT = function boolPT(is) {
  return (0, _isRequired2.default)(bool, is);
};

var emptyObjectPT = exports.emptyObjectPT = function emptyObjectPT(is) {
  return (0, _isRequired2.default)(_empty.emptyObject, is);
};

var funcPT = exports.funcPT = function funcPT(is) {
  return (0, _isRequired2.default)(func, is);
};

var momentObjectPT = exports.momentObjectPT = function momentObjectPT(is) {
  return (0, _isRequired2.default)(_reactMomentProptypes.momentObj, is);
};

var momentObjectOrStringPT = exports.momentObjectOrStringPT = function momentObjectOrStringPT(is) {
  return (0, _isRequired2.default)(oneOfType([_reactMomentProptypes.momentObj, _reactMomentProptypes.momentString]), is);
};

var momentStringPT = exports.momentStringPT = function momentStringPT(is) {
  return (0, _isRequired2.default)(_reactMomentProptypes.momentString, is);
};

var nodePT = exports.nodePT = function nodePT(is) {
  return (0, _isRequired2.default)(node, is);
};

var numberOrStringPT = exports.numberOrStringPT = function numberOrStringPT(is) {
  return (0, _isRequired2.default)(oneOfType([number, string]), is);
};

var numberPT = exports.numberPT = function numberPT(is) {
  return (0, _isRequired2.default)(number, is);
};

var stringPT = exports.stringPT = function stringPT(is) {
  return (0, _isRequired2.default)(string, is);
};